module.exports = __webpack_public_path__ + "img/logo_unisuper.12d66121.svg";